import { SupportsOfRefundRequestInvoiceItem } from "./supports-of-request-refund-invoice-item.model";

export class RefundRequestInvoiceItem{
    constructor(
        public idFacturaItem? : string, //idInvoiceItem
        public idFactura? : string, //idInvoice
        public nitFactura? : string, //nitCompanyInvoice
        public idEspecialidadReembolso? : string, //idEspecialidadRefund
        public nombreEspecialidadReembolso? : string, //nameEspecialidadRefund
        public montoFactura? : string, //amountInvoice
        public fechaFactura? : string, //dateInvoice
        public soportesDeFacturaItem? : SupportsOfRefundRequestInvoiceItem[],
    )
    {
        this.soportesDeFacturaItem = [];
    }
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/request-refund-invoice-item.model.ts